import { inject } from '@angular/core';
import { CanActivateFn, Route, Router } from '@angular/router';

const stripV2Prefix: CanActivateFn = (route) => {
  const router = inject(Router);
  const remainingPath = route.url.map((segment) => segment.path).join('/');
  return router.createUrlTree([`/${remainingPath}`], { queryParams: route.queryParams });
};

export const appRoutes: Route[] = [
  {
    path: 'v2',
    children: [
      { path: '**', canActivate: [stripV2Prefix], children: [] }
    ]
  },
  {
    path: '',
    data: { name: 'home', title: 'Home', modules: ['default'] },
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule)
  }
];
